/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { t } from '@sportninja/common/i18n'
import parsers from '@sportninja/common/reducers/parsers'
import { connect } from 'react-redux'
import orgActions from '@sportninja/common/actions/org'
import scheduleActions from '@sportninja/common/actions/schedule'
import { bindActionToPromise } from '@sportninja/common/actions/utils'
import req from '@sportninja/common/api/request'

import MapCard from '../MapCard'
import { NewMapCard } from '../NewMapCard'
import { venueForm } from '../Form/form-configs'
import ListStatusView from '../List/StatusView'
import useGetListItems from '../List/useGetListItems'
import { Flex } from '../Layout'
import { ENTITY_TYPES } from '@sportninja/common/sagas/utils'
import { NewModal } from '../NewModal'
import LoadingSpinner from '../LoadingSpinner'
import { NewLocationAddressSelector } from '../NewLocationAddressSelector'
import Icon from '../Icon'
import colors from '@sportninja/common/constants/appColors'
import { isCanlan } from '@sportninja/common/utils/customer-name'

const sorter = (a, b) => {
  const nameA = a.name_full,
    nameB = b.name_full
  if (nameA < nameB) return -1
  else if (nameA > nameB) return 1

  return 0
}

const Venues = ({
  entityType,
  id,
  slug,
  refreshKey,
  triggerRefresh,
  query,

  updateOrgVenue,
  deleteOrgVenue,
  updateScheduleVenue,
  deleteScheduleVenue,
  parentPermission,
}) => {
  const { loading, error, items, sort, direction, getItems } = useGetListItems(
    slug,
    { query }
  )
  const [selectedVenue, setSelectedVenue] = useState(null)
  const [isLoadingVenue, setIsLoadingVenue] = useState(false)

  const locationModalRef = useRef(null)

  const entity = useMemo(() => entityType === ENTITY_TYPES.org ? 'organizations' : 'schedules', [entityType])

  useEffect(() => {
    getItems(1, query)
  }, [refreshKey, sort, direction])

  let onUpdate, onDelete

  if (entityType === ENTITY_TYPES.org) {
    onUpdate = updateOrgVenue
    onDelete = deleteOrgVenue
  } else if (entityType === ENTITY_TYPES.schedule) {
    onUpdate = updateScheduleVenue
    onDelete = deleteScheduleVenue
  }

  // const onUpdateVenue = useCallback(async (data) => {
  //   console.log('DATA', data)
  //   setIsLoadingVenue(true)

  //   const body = {
  //     address_line1: data?.args?.address_line1,
  //     address_line2: data?.args?.address_line2,
  //     city: data?.args?.city,
  //     postcode: data?.args?.postcode,
  //     country: data?.args?.country,
  //     state: data?.args?.state,
  //     name: data?.args?.name,
  //     timezone: data?.args?.timezone,
  //     latitude: data?.args?.latitude,
  //     longitude: data?.args?.longitude,
  //   }

  //   try {
  //     const response = await req(
  //       `/${entity}/${id}/venues/${selectedVenue.id}`,
  //       {
  //         method: 'PUT',
  //         body: JSON.stringify(body),
  //       }
  //     )

  //     if (data.facilities?.length > 0) {
  //       for (let index = 0; index < data.facilities?.length; index++) {
  //         const facility = data.facilities?.[index]

  //         const existingFacility = selectedVenue?.facilities?.find(
  //           (f) => f.id === facility.id
  //         )

  //         if (existingFacility && facility.name !== existingFacility.name) {
  //           await req(
  //             `/${entity}/${id}/venues/${selectedVenue.id}/facilities/${facility.id}`,
  //             {
  //               method: 'PUT',
  //               body: JSON.stringify({ name: facility.name }),
  //             }
  //           )
  //         } else if (
  //           existingFacility &&
  //           facility.name === existingFacility.name
  //         ) {
  //           return
  //         } else if (!existingFacility) {
  //           await req(
  //             `/${entity}/${id}/venues/${selectedVenue.id}/facilities`,
  //             {
  //               method: 'POST',
  //               body: JSON.stringify({ name: facility.name }),
  //             }
  //           )
  //         }
  //       }
  //     }
  //   } catch (error) {
  //     console.error(error)
  //   } finally {
  //     setIsLoadingVenue(false)
  //     locationModalRef?.current?.closeModal()
  //     triggerRefresh()
  //   }
  // }, [id, selectedVenue])

  const onDeleteVenue = useCallback(async (venueId) => {
    if (window.confirm('Are you sure you want to delete this location?')) {
      try {
        await req(`/${entity}/${id}/venues/${venueId}`, {
          method: 'DELETE',
        })
      } catch (error) {
        console.error(error)
      } finally {
        triggerRefresh()
      }
    }
  }, [])

  return (
    <>
      <Flex
        row
        flexWrap
        // css={css`
        //   gap: 20px;
        //   padding-top: 16px;
        //   justify-content: flex-start;
        // `}
      >
        {loading || error || items.length === 0 ? (
          <div style={{ margin: '0 auto' }}>
            <ListStatusView
              loading={loading}
              error={error}
              zeroItems={items.length === 0}
              noItemsText={t('common:location', { count: 2 })}
            />
          </div>
        ) : (
          items.sort(sorter).map((item) => {
            const venue = parsers.venue(item)

            return (
              <MapCard
                disableMobileVersion
                noTitle
                key={venue.id}
                venue={venue}
                onUpdate={
                  parentPermission?.update && onUpdate
                    ? async (form) => {
                        const response = await onUpdate(id, venue.id, form)
                        triggerRefresh()
                        return response
                      }
                    : undefined
                }
                onDelete={
                  parentPermission?.delete && onDelete
                    ? async () => {
                        const response = await onDelete(id, venue.id)
                        triggerRefresh()
                        return response
                      }
                    : undefined
                }
                updateForm={venueForm(venue, id, entityType)}
                updateTitle={t('Web:editLocation')}
              />
              // <NewMapCard
              //   name={venue?.fullName}
              //   description={venue?.addressString}
              //   latitude={venue?.coords?.[0] || null}
              //   longitude={venue?.coords?.[1] || null}
              //   key={venue.id}
              //   onDeleteClick={() => onDeleteVenue(venue.id)}
              //   onUpdateClick={() => {
              //     setSelectedVenue(venue)
              //     locationModalRef?.current?.openModal()
              //   }}
              // />
            )
          })
        )}
      </Flex>
      {/* <NewModal ref={locationModalRef} shouldCloseOnOverlayClick={false}>
        <div
          css={css`
            width: 40vw;
            background: no-repeat fixed linear-gradient(#282e38, #181a1d);
            max-height: 80vh;
            border-radius: 8px;
            padding: 20px;
            display: flex;
            flex-direction: column;
            overflow-y: auto;
            transition: all 0.1s ease-in-out;
          `}
        >
          <div
            css={css`
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding-bottom: 16px;
              border-bottom: 1px solid ${colors.SOFT_STEEL};
              margin-bottom: 16px;
            `}
          >
            <h1
              css={css`
                font-size: 36px;
                font-family: ${isCanlan
                  ? 'Neue Plak Condensed, Arial, Helvetica, sans-serif;'
                  : 'Rift, Arial, Helvetica, sans-serif'};
                font-weight: 700;
              `}
            >
              {t('Web:editLocation')}
            </h1>
            <button
              onClick={() => locationModalRef.current.closeModal()}
              // disabled={isLoadingVenue}
            >
              <Icon name='times' color={colors.ATTENDANCE_GRAY} fontSize={20} />
            </button>
          </div>
          <div
            css={css`
              flex: 1;
              flex-grow: 1;
              display: flex;
              transition: all 0.1s ease-in-out;
            `}
          >
            {isLoadingVenue ? (
              <div
                css={css`
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  flex: 1;
                `}
              >
                <LoadingSpinner />
              </div>
            ) : (
              <NewLocationAddressSelector
                initialState={{
                  address_line1: selectedVenue?.address?.street_1 || '',
                  address_line2: selectedVenue?.address?.street_2 || '',
                  city: selectedVenue?.address?.city || '',
                  postcode: selectedVenue?.address?.postal_code || '',
                  country: selectedVenue?.address?.country?.name || '',
                  latitude: selectedVenue?.address?.latitude || 0,
                  longitude: selectedVenue?.address?.longitude || 0,
                  name: selectedVenue?.fullName || '',
                  state: selectedVenue?.address?.province?.name || '',
                  timezone: selectedVenue?.timezone || '',
                }}
                initialFacilities={selectedVenue?.facilities || []}
                onCancel={() => locationModalRef?.current?.closeModal()}
                onSubmit={onUpdateVenue}
              />
            )}
          </div>
        </div>
      </NewModal> */}
    </>
  )
}

Venues.propTypes = {
  entityType: PropTypes.string,
  id: PropTypes.string.isRequired,
  onUpdate: PropTypes.func,
  onDelete: PropTypes.func,
  onEdit: PropTypes.func,
  venues: PropTypes.array,
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateOrgVenue: bindActionToPromise(
      dispatch,
      orgActions.venues.update.request
    ),
    deleteOrgVenue: bindActionToPromise(
      dispatch,
      orgActions.venues.delete.request
    ),
    updateScheduleVenue: bindActionToPromise(
      dispatch,
      scheduleActions.venues.update.request
    ),
    deleteScheduleVenue: bindActionToPromise(
      dispatch,
      scheduleActions.venues.delete.request
    ),
  }
}

export default connect(null, mapDispatchToProps)(Venues)
